import React from 'react'
import styled from 'styled-components'
import { text } from '../styles/mixins/text'
import { Icon, IconKey } from './Icon/index'
import { Spacer } from './Spacer'

type Props = {
    message: string
    iconKey?: IconKey
}

export const NoneMessage = ({ message, iconKey = 'File' }: Props): JSX.Element => {
    return (
        <Container>
            <Icon iconKey={iconKey} size={6} color="secondary" />
            <Spacer vertical size={2} />
            {message}
        </Container>
    )
}

const Container = styled.div`
    ${text('paragraph', 'secondary')}
    margin: auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
`
